var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: { title: _vm.title, width: "900px", height: "545px", top: "10vh" },
      on: { success: _vm.successFn },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "ele-tabs-wrap",
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabClick },
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            },
            _vm._l(_vm.types, function (item) {
              return _c(
                "el-tab-pane",
                { key: item, attrs: { name: _vm.tabs[item].type } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(" " + _vm._s(_vm.tabs[item].name) + " ( "),
                    item === 0
                      ? _c("span", [_vm._v(_vm._s(_vm.imageList.length))])
                      : item === 1
                      ? _c("span", [_vm._v(_vm._s(_vm.audioList.length))])
                      : item === 2
                      ? _c("span", [_vm._v(_vm._s(_vm.videoList.length))])
                      : _c("span", [_vm._v(_vm._s(_vm.fileList.length))]),
                    _vm._v(" ) "),
                  ]),
                ]
              )
            }),
            1
          ),
          _vm.type === "imageView"
            ? _c(
                "div",
                [
                  _c("imageView", {
                    ref: "goodsView",
                    attrs: {
                      "max-size": _vm.maxSize,
                      classlist: _vm.classlist.imageClass,
                      "file-type": _vm.fileType,
                    },
                    model: {
                      value: _vm.imageList,
                      callback: function ($$v) {
                        _vm.imageList = $$v
                      },
                      expression: "imageList",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === "audioView"
            ? _c(
                "div",
                [
                  _c("audioView", {
                    ref: "goodsView",
                    attrs: {
                      classlist: _vm.classlist.audioClass,
                      "file-type": _vm.fileType,
                    },
                    model: {
                      value: _vm.audioList,
                      callback: function ($$v) {
                        _vm.audioList = $$v
                      },
                      expression: "audioList",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === "videoView"
            ? _c(
                "div",
                [
                  _c("videoView", {
                    ref: "goodsView",
                    attrs: {
                      classlist: _vm.classlist.videoClass,
                      "file-type": _vm.fileType,
                    },
                    model: {
                      value: _vm.videoList,
                      callback: function ($$v) {
                        _vm.videoList = $$v
                      },
                      expression: "videoList",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === "fileView"
            ? _c(
                "div",
                [
                  _c("fileView", {
                    ref: "goodsView",
                    attrs: {
                      classlist: _vm.classlist.fileClass,
                      "file-type": _vm.fileType,
                    },
                    model: {
                      value: _vm.fileList,
                      callback: function ($$v) {
                        _vm.fileList = $$v
                      },
                      expression: "fileList",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }